(function () {
  var markerPattern = /\[(?:text|wide|full|products_[1-5]|single_photo_\d+|double_photo_\d+|slideshow_[1-5])(?::(?:text|wide|full|frame-left|frame-right|frame-both))*\]/gi;

  function cleanExcerpt(element) {
    if (!element) return;

    var cleaned = (element.textContent || '')
      .replace(markerPattern, ' ')
      .replace(/\s+/g, ' ')
      .trim();

    element.textContent = cleaned;

    if (!cleaned) {
      element.hidden = true;
    }
  }

  function initialize(root) {
    (root || document)
      .querySelectorAll('.editorial-blog__hero-excerpt, .editorial-card__excerpt')
      .forEach(cleanExcerpt);
  }

  document.addEventListener('DOMContentLoaded', function () {
    initialize(document);
  });

  document.addEventListener('shopify:section:load', function (event) {
    initialize(event.target);
  });
})();